<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="850" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading" title="产品评级">
			<template #default>
				<el-row :gutter="20" style="font-size: 20px;font-weight: bold;">
					<el-col :span="5">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							S级：{{percent.S.count +' / '+ percent.S.percent+'%'}}
						</div>
					</el-col>
					<el-col :span="5">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							A级：{{percent.A.count +' / '+ percent.A.percent+'%'}}
						</div>
					</el-col>
					<el-col :span="5">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							B级：{{percent.B.count +' / '+ percent.B.percent+'%'}}
						</div>
					</el-col>
					<el-col :span="5">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							C级：{{percent.C.count +' / '+ percent.C.percent+'%'}}
						</div>
					</el-col>
					<el-col :span="5">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							D级：{{percent.D.count +' / '+ percent.D.percent+'%'}}
						</div>
					</el-col>
				</el-row>

				<el-divider content-position="left">综合权重</el-divider>
				<vxe-form>
					<vxe-form-item title="30天权重">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="0.1" v-model="param.a30"
								@change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="30~60天权重">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="0.1" v-model="param.a60"
								@change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="60~90天权重">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="0.1" v-model="param.a90"
								@change="change"></el-input-number>
						</template>
					</vxe-form-item>
				</vxe-form>
				<el-divider content-position="left">评级参数</el-divider>
				<vxe-form>
					<vxe-form-item title="S级次数">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="1"
								v-model="param.level.s.count" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="S级金额">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.s.weightingamount" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="S级成本">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.s.purchasingcost" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
				</vxe-form>
				<vxe-form>
					<vxe-form-item title="A级次数">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="1"
								v-model="param.level.a.count" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="A级金额">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.a.weightingamount" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="A级成本">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.a.purchasingcost" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
				</vxe-form>
				<vxe-form>
					<vxe-form-item title="B级次数">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="1"
								v-model="param.level.b.count" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="B级金额">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.b.weightingamount" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="B级成本">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.b.purchasingcost" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
				</vxe-form>
				<vxe-form>
					<vxe-form-item title="C级次数">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="1"
								v-model="param.level.c.count" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="C级金额">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.c.weightingamount" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
					<vxe-form-item title="C级成本">
						<template #default>
							<el-input-number controls-position="right" size="mini" :step="10"
								v-model="param.level.c.purchasingcost" @change="change"></el-input-number>
						</template>
					</vxe-form-item>
				</vxe-form>
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="primary" @click="getBaseData">导入计算</vxe-button>
						<vxe-button status="danger" @click="reset">重置</vxe-button>
						<vxe-button status="" @click="exportdata">导出</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="goodsrate" :loading="computeloading" border show-overflow height="350"
					:scroll-y="{enabled: true}" :data="tableData" >
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="id" title="商品ID"></vxe-column>
					<vxe-column field="code" title="商品编码"></vxe-column>
					<vxe-column field="name" title="商品名称"></vxe-column>
					<vxe-column field="model" title="规格型号"></vxe-column>
					<vxe-column field="weight" title="重量"></vxe-column>
					<vxe-column field="cost" title="采购单价"></vxe-column>
					<vxe-column field="tmprice" title="天猫价"></vxe-column>
					<vxe-column field="weightingsize" title="综合数量"></vxe-column>
					<vxe-column field="weightingamount" title="综合金额"></vxe-column>
					<vxe-column field="purchasingcost" title="采购成本"></vxe-column>
					<vxe-column field="count180" title="180天次数"></vxe-column>
					<vxe-column field="oldlevel" title="往期评级"></vxe-column>
					<vxe-column field="level" title="本次评级"></vxe-column>
					<vxe-column field="correctbottom" title="最大下限(不超过100kg)"></vxe-column>
					<vxe-column field="bottom" title="下限"></vxe-column>
					<vxe-column field="top" title="上限"></vxe-column>
					<vxe-column field="duration" title="创建时长(天)"></vxe-column>

					<vxe-column field="purchases" title="采购单" :visible="false"></vxe-column>
					<vxe-column field="size30" title="30天销数" :visible="false"></vxe-column>
					<vxe-column field="warehousewlnid" title="仓库WLNID" :visible="false"></vxe-column>
					<vxe-column field="warehousename" title="仓库名称" :visible="false"></vxe-column>
					<vxe-column field="warehousecount" title="发货次数" :visible="false"></vxe-column>
					<vxe-column field="warehousesize" title="发货件数" :visible="false"></vxe-column>
					<vxe-column field="warehousepercnet" title="占比" :visible="false"></vxe-column>
					<vxe-column field="nDay" title="流转周期" :visible="false"></vxe-column>
					<vxe-column field="nDaySale" title="流转周期数量" :visible="false"></vxe-column>
					<vxe-column field="warehousegetday" title="到货时效" :visible="false"></vxe-column>
					<vxe-column field="warehousecustomizedday" title="定制天数" :visible="false"></vxe-column>
					<vxe-column field="warehouseoldbottom" title="往期仓库下限" :visible="false"></vxe-column>
					<vxe-column field="warehouseoldtop" title="往期仓库上限" :visible="false"></vxe-column>
					<vxe-column field="warehousecustombottom" title="自定义下限" :visible="false"></vxe-column>
					<vxe-column field="warehousecustomtop" title="自定义上限" :visible="false"></vxe-column>					
					<vxe-column field="warehousebottom" title="本次仓库下限" :visible="false"></vxe-column>
					<vxe-column field="warehousetop" title="本次仓库上限" :visible="false"></vxe-column>

					<vxe-column type="expand" title="明细" width="60">
						<template #content="{ row }">
							<div class="flex" style="box-sizing: border-box;margin: 10px;flex-direction: row;">
								<div style="width: 200px;display: inline-block;" v-for="(item,index) in row.warehouse"
									:key="index">
									<!-- <div>ID：{{item.storageID}}</div> -->
									<div>名称：{{ item.storage_name }}</div>
									<div>出库次数：{{ item.count }}</div>
									<div>出库件数：{{ item.size }}</div>
									<div>占比：{{ item.percent.toFixed(2) }}</div>
									<div>下限：{{ item.bottom }}</div>
									<div>上限：{{ item.top }}</div>
									<div>往期下限：{{ item.oldbottom }}</div>
									<div>往期上限：{{ item.oldtop }}</div>
								</div>
							</div>
						</template>
					</vxe-column>
				</vxe-table>
			</template>
			<template #footer>
				<vxe-button size="mini" status="primary" content="提交任务" @click="submit"></vxe-button>
			</template>


		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import {adminMixin} from './project/admin/mixin.js'
	import {liutiMixin} from './project/liuti/mixin.js'
	
	let mixin = window.config.company === 'liuti'
		? liutiMixin 
		: adminMixin
	export default {
		mixins:[mixin],
		props: {

		},
		// data() {
			
		// },
		created() {

		},
		mounted() {
			this.days = (this.param.a30 + this.param.a60 + this.param.a90) * 30
		},
		watch: {

		},
		computed: {

		},

		methods: {
			
		},
		components: {

		}
	}
</script>